import { useEffect } from 'react';

import { NavLink } from 'react-router-dom';

import { Box, useMediaQuery, useTheme } from '@mui/material';

import { AppIcon } from '~components/shared/app-icon/app-icon';
import { AppTypography } from '~components/ui/typography/app-typography';

import { useActiveScope } from '~hooks/use-active-scope';
import { useMobileMenu } from '~hooks/use-mobile-menu';

import { ROUTES } from '~app/router/routes';

import { ReactComponent as IconReminder } from '~assets/icons/icon-bell.svg';
import { ReactComponent as IconBill } from '~assets/icons/icon-bill.svg';
import { ReactComponent as IconBuilding } from '~assets/icons/icon-building-1.svg';
import { ReactComponent as IconChart } from '~assets/icons/icon-chart-1.svg';
import { ReactComponent as IconContract2 } from '~assets/icons/icon-contract-2.svg';
import { ReactComponent as IconDashboard } from '~assets/icons/icon-dashboard.svg';
import { ReactComponent as IconUsers } from '~assets/icons/icon-users.svg';

const lessorRoutes = [
  {
    route: ROUTES.PROPERTIES,
    icon: IconBuilding,
    title: 'Нерухомість',
  },
  {
    route: ROUTES.DASHBOARD,
    icon: IconChart,
    title: 'Огляд',
  },
  {
    route: ROUTES.REMINDERS,
    icon: IconReminder,
    title: 'Нагадування',
  },
  {
    route: ROUTES.TENANTS,
    icon: IconUsers,
    title: 'Орендарі',
  },
];

const tenantRoutes = [
  {
    route: ROUTES.TENANT_LEASES,
    icon: IconContract2,
    title: 'Договори',
  },
  {
    route: ROUTES.TENANT_SCOPE,
    icon: IconDashboard,
    title: 'Огляд',
  },
  {
    route: ROUTES.TENANT_REMINDERS,
    icon: IconReminder,
    title: 'Нагадування',
  },
  {
    route: ROUTES.TENANT_INVOICES,
    icon: IconBill,
    title: 'Рахунки',
  },
];

export const BottomNavigation = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { isMenuOpen } = useMobileMenu();
  const scope = useActiveScope();

  useEffect(() => {
    if (isMobile) {
      document.body.style.paddingBottom = '74px';
    } else {
      document.body.style.paddingBottom = '0';
    }

    return () => {
      document.body.style.paddingBottom = '0';
    };
  }, [isMobile]);

  const routes = scope === 'lessor' ? lessorRoutes : tenantRoutes;

  return (
    <Box
      sx={{
        width: '100%',
        height: 62,
        position: 'fixed',
        bottom: 0,
        left: 0,
        backgroundColor: 'fog.90',
        borderTop: '1px solid',
        borderColor: 'fog.85',
        zIndex: 9,
        padding: 1,
        boxSizing: 'border-box',
        transition: '.2s transform',
        transform: isMenuOpen ? 'translateY(100%)' : 'translateY(0)',

        display: {
          xs: 'flex',
          md: 'none',
        },

        justifyContent: 'space-between',
      }}
    >
      {routes.map((route) => (
        <NavLink
          key={route.route}
          to={route.route}
          style={{
            textDecoration: 'none',
            width: '25%',
          }}
          end={scope === 'tenant'}
        >
          {({ isActive }) => (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',

                color: isActive ? 'primary.100' : 'neutral.30',
              }}
            >
              <AppIcon component={route.icon} sx={{ mb: 0.5 }} size={22} />
              <AppTypography size={'body-caption'} weight={'semibold'}>
                {route.title}
              </AppTypography>
            </Box>
          )}
        </NavLink>
      ))}
    </Box>
  );
};
